module.exports = __webpack_public_path__ + "media/img/seed/9-10091da63b0410edb9f10606e1420022.jpeg";